import React from "react";
import "./About.css";
import { motion } from "framer-motion";

const AboutHero = () => {
  return (
    <section className="about-hero">

      <div className="hero-container">
        <motion.div
          className="hero-left"
          initial={{ opacity: 0, y: 80 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >

          <h2 className="hero_head">
            We Build AI-Powered 
            Future-Ready Products
          </h2>

          <p className="hero-text">
            Helping startups and enterprises scale with automation,
            AI systems, and high-performance digital solutions.
          </p>

        </motion.div>

        <div className="hero-right">

           <div className="blob">
            <img className="cover-img"
              src="./about-hero.webp"
              alt="team"
              loading="lazy"
            />
          </div>

        </div>

      </div>
    </section>
  );
};

export default AboutHero;